import icon from '@/presentation/assets/images/icons/shield-crack-black.svg';
import type { CustomQueryParams } from '@/services/router-proxy/types';
import { type Manifest, PAGE_TYPE, type RouterConfig, type ToolConfig } from '@/types/manifest';

const routerConfig: RouterConfig = {
    type: PAGE_TYPE.TOOL,
    name: 'invalid-search',
    exclusiveRoutePath: '/invalid-search/:invalidSearchPath(.*)?',
    getComponent: () => import('./InvalidSearchEntry.vue'),
};

const toolConfig: ToolConfig = {
    tabIndex: 5,
    label: 'drafting.InvalidSearch',
    icon,
    aclCheckPath: () => true,
};

export const manifest: Manifest = {
    ...routerConfig,
    ...toolConfig,
};

declare module '@patsnap/tahiti-core' {
    export interface CommandService {
        /** 进入专利无效检索入口或其指定子路径。 */
        executeCommand(commandId: 'command:route:invalid-search', params?: CustomQueryParams): void;
    }
}
